import React, { useEffect, useState } from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import { useParams } from "react-router-dom";
import axios from "axios";
import Loader from "./Components/Loader";

const CoursePagedb = () => {
    const { title } = useParams();

    const [courses, setCourses] = useState([]);

    
  useEffect(() => {
    const fetchCoursesServices = async () => {
      try {
        const response = await axios.get(
          "https://us-central1-janushreebeautyparlour.cloudfunctions.net/api/getCoursesSection1",
          {
            params: { title },
          }
        );
        setCourses(response.data);
        console.log("responseofcourses:", response.data);
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    fetchCoursesServices();
  }, [title]);

  const handleDownload = (pdfUrl) => {
    if (!pdfUrl) {
      console.error("PDF URL is undefined");
      return; 
    }
  
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.target = "_blank";
    link.download = pdfUrl.split('/').pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  const handleEnrollClick = () => {
    window.open("https://wa.me/919841424435", "_blank");
};

    return(
        <>
      <Header />
      {courses.map((course, index) => (
      <div  key={index} className="training-section">
        <div className="training-section__row">
          <div className="glass-card">
            <h2 className="blackthemegradient">Who Is This Training For?</h2>
            <ul>
                {course.subtitles2.map((item, idx) => (
                  <li style={{color:"white"}} key={idx}>{item.subdescription}</li>
                ))}
              </ul>
          </div>
          <div className="training-section__image">
            <img src={course.imageUrl} alt="Beauty Training" />
          </div>
        </div>

        <div className="training-section__row">
          <div className="glass-card">
            <h2 className="blackthemegradient">What Is Covered in the Training?</h2>
            <ul>
                {course.subtitles.map((item, idx) => (
                  <li style={{color:"white"}} key={idx}>{item.subdescription}</li>
                ))}
              </ul>
          </div>
          <div className="glass-card">
            <h2 className="blackthemegradient">Key Topics</h2>
            <ul>
                {course.subtitles3.map((item, idx) => (
                  <li style={{color:"white"}} key={idx}>{item.subdescription}</li>
                ))}
              </ul>
          </div>
        </div>

        <div className="download-section">
        <button
          className="download-button"
          onClick={() => handleDownload(course.pdfUrl)} // Ensure `course.pdfUrl` is correct
        >
          Download
        </button>
        <button className="enroll-btn" onClick={handleEnrollClick} 
                        style={{
                                    backgroundColor: "#A890FE", 
                                    color: "#fff", 
                                    padding: "10px 20px", 
                                    borderRadius: "5px", 
                                    border: "none", 
                                    cursor: "pointer", 
                                    width: "100px",
                                }}
                            >
                                Enroll
                            </button>
        </div>
      </div>
    ))}
    <Loader/>
      <Footer />
      </>
    );
}

export default CoursePagedb;